import { Alert, AlertTitle, Typography } from "@mui/material";
import { useContext } from "react";
import Loadable from "react-loadable";
import { Route, Switch, useParams } from "react-router-dom";
import Sidebar, {
    orgadmin_modules,
    superadmin_modules,
} from "./components/dashboard/Sidebar";
import Loading from "./components/Loading";
import SignIn from "./components/Login/Login";
import UserContext from "./components/UserContext";
import { Global_CTX } from "./contexts/global-ctx";
import SimpleDashboard from "./components/SimpleDashboard/SimpleDashboard";
import Authenticate from "./components/Authenticate";

const AsyncOfflinePage = Loadable({
    loader: () => import("./components/Auth/OfflinePage"),
    loading: Loading,
});

const AsyncAuthorizeAsType = Loadable({
    loader: () => import("./components/Auth/AuthorizeAsTypes"),
    loading: Loading,
});

const AsyncAuthenticate = Loadable({
    loader: () => import("./components/Authenticate"),
    loading: Loading,
});

const AsyncFourOfFour = Loadable({
    loader: () => import("./components/FourOfFour"),
    loading: Loading,
});

const AsyncMultiPermissionAuthorize = Loadable({
    loader: () => import("./components/MultiPermissionAuthorize"),
    loading: Loading,
});
const AsyncLayout = Loadable({
    loader: () => import("./components/layout"),
    loading: Loading,
});

const Fallback = () => {
    return (
        <Alert style={{ margin: "8px" }} severity="error">
            <AlertTitle>Access Denied</AlertTitle>
            You do not have the clearance to access this page
        </Alert>
    );
};

export const Routes = () => {
    const { user } = useContext(UserContext);
    const { permissions } = useContext(Global_CTX);
    const params = useParams();

    return (
        <AsyncLayout
            setComponent={() => {}}
            permissions={permissions}
            sidebar={
                user ? (
                    <Sidebar variant={"user"} setComponent={() => {}} />
                ) : null
            }
        >
            <Switch>
                <Route exact path="/">
                    <Authenticate then={() => {}}>
                        <></>
                    </Authenticate>
                </Route>

                <Route exact path={["/superadmin", "/admin"]}>
                    <Authenticate then={() => {}}>
                        <SimpleDashboard />
                    </Authenticate>
                </Route>

                <Route exact path="/offline">
                    <AsyncOfflinePage />
                </Route>

                <Route exact path="/:user_type/login">
                    <SignIn />
                </Route>

                {/* <Route exact path="/role/update/:id">
                    <AsyncAuthenticate>
                        <AsyncCreateRole mode="edit" />
                    </AsyncAuthenticate>
                </Route>

                <Route exact path="/role/read/:id">
                    <AsyncAuthenticate>
                        <AsyncCreateRole mode="read" />
                    </AsyncAuthenticate>
                </Route> */}

                {/* <Route exact path="/create-role">
                    <AsyncAuthenticate>
                        <CreateRole />
                         
                    </AsyncAuthenticate>
                </Route> */}

                {Object.values(superadmin_modules)
                    .flat()
                    .map((subModule, idx) => (
                        <Route exact path={`${subModule.href}`} key={idx}>
                            <AsyncAuthenticate then={() => {}}>
                                {/* <AsyncAuthorizeAsType types={["superadmin"]}>
                                    <AsyncMultiPermissionAuthorize
                                        strategy="some"
                                        ops={subModule.permissions || []}
                                        fallback={<Fallback />}
                                    > */}
                                {subModule.component}
                                {/* </AsyncMultiPermissionAuthorize>
                                </AsyncAuthorizeAsType> */}
                            </AsyncAuthenticate>
                        </Route>
                    ))}

                {Object.values(orgadmin_modules)
                    .flat()
                    .map((subModule, idx) => (
                        <Route exact path={`${subModule.href}`} key={idx}>
                            <AsyncAuthenticate then={() => {}}>
                                {/* <AsyncAuthorizeAsType types={["superadmin"]}>
                                    <AsyncMultiPermissionAuthorize
                                        strategy="some"
                                        ops={subModule.permissions || []}
                                        fallback={<Fallback />}
                                    > */}
                                {subModule.component}
                                {/* </AsyncMultiPermissionAuthorize>
                                </AsyncAuthorizeAsType> */}
                            </AsyncAuthenticate>
                        </Route>
                    ))}

                {/* FACULTY */}
                {/* {Object.values(facultyModules)
                    .flat()
                    .map((subModule: any, idx) => (
                        <Route exact path={`${subModule.href}`} key={idx}>
                            <AsyncAuthenticate then={() => {}}>
                                <AsyncAuthorizeAsType
                                    types={[user?.user_type ?? "admin"]}
                                >
                                    <AsyncMultiPermissionAuthorize
                                        strategy="all"
                                        ops={subModule.permissions || []}
                                        fallback={<Fallback />}
                                    >
                                        {subModule.component}
                                    </AsyncMultiPermissionAuthorize>
                                </AsyncAuthorizeAsType>
                            </AsyncAuthenticate>
                        </Route>
                    ))} */}

                {/* {Object.values(studentModules)
                    .flat()
                    .map((subModule: any, idx) => (
                        <Route exact path={`${subModule.href}`} key={idx}>
                            <AsyncAuthenticate then={() => {}}>
                                <AsyncAuthorizeAsType types={["student"]}>
                                    <AsyncMultiPermissionAuthorize
                                        strategy="all"
                                        ops={subModule.permissions || []}
                                        fallback={<Fallback />}
                                    >
                                        {subModule.component}
                                    </AsyncMultiPermissionAuthorize>
                                </AsyncAuthorizeAsType>
                            </AsyncAuthenticate>
                        </Route>
                    ))} */}

                <Route exact path="*">
                    <AsyncFourOfFour />
                </Route>
            </Switch>
        </AsyncLayout>
    );
};
